import React, {useState, useEffect} from 'react'
import AppToolBar from '../common/AppToolBar'
import Header from '../common/Header'
import { getEventDetailsWithDistkey, getMapData } from '../../apis/eventService'
import moment from 'moment'
import RelayLeaderboard from './registration/events/viewResults/Relay/RelayLeaderboard'
import { useSelector } from 'react-redux'

function LiveMap() {
    const [relayMapData, setRelayMapData] = useState(null)
  const userSelectedEvent = useSelector(
    (state) => state.user.userSelectedEvent
  );


  

  
    useEffect(()=>{
        let distKey = "b+AwHrotYWQ8XOTmdAYbyw=="
        getEventDetailsWithDistkey(userSelectedEvent && userSelectedEvent?.distKey || distKey)
        .then((res) => {
          if (res.status === 200) {

            console.log(res.data , "data");
            
            // document.title = `Results - ${res?.data?.name}`;
            document.title = res?.data?.name;
            let eventData = res.data;
            eventData.distKey = distKey;

    

        

            if (res.data?.mapGenerated) {
              
              if (res.data?.mapToShow === "RELAY") {
                let isLive = moment().isAfter(eventData?.eventLocalEndDate);
                let eventDateTime = moment(
                  eventData?.eventDate + " " + eventData?.eventTime
                );
                let current = moment();
                let timeRemained = eventDateTime.diff(current);
                // if(!search?.includes('#participants'))
                //  added two line support 
                if(res?.data?.displayMultipleRoute){
                loadMapData(eventData , timeRemained , isLive);
                }else{

                    getMapData(eventData?.id).then((relayRes) => {
                        
                                    setRelayMapData(
                                    {
                                    live: isLive,
                                    flightPlanCoordinates: relayRes?.data
                                        ?.coOrdinatePointsJson
                                        ? JSON.parse(relayRes?.data?.coOrdinatePointsJson)
                                        : null,
                                    center: relayRes?.data?.centerPoint?.coOrdinatePoint
                                        ? relayRes?.data?.centerPoint?.coOrdinatePoint
                                        : null,
                                    defaultCenter:
                                        relayRes?.data?.centerPoint?.coOrdinatePoint,
                                    features: relayRes?.data?.markerPointDTOs
                                        ? relayRes?.data?.markerPointDTOs
                                        : null,
                                    timeRemained: timeRemained,
                                    },
                                )
                                });
                }
                            
             
               
              }
            }
          }
        })
        .catch((error) => {
          if (error) {
            // history.push(`/event?distKey=${distKey}`);
          }
        });
    },[])



    const loadMapData = async (eventData, timeRemained, isLive) => {
        try {
                  const results = await Promise.allSettled([
                    getMapData(507),
                    getMapData(678),
                    ])

                    const route1 =
                    results[0].status === 'fulfilled' ? results[0].value?.data : null

                    const route2 =
                    results[1].status === 'fulfilled' ? results[1].value?.data : null


                    setRelayMapData({
                    live: isLive,

                    // -------- Route 1 --------
                    flightPlanCoordinates: route1?.coOrdinatePointsJson
                        ? JSON.parse(route1.coOrdinatePointsJson)
                        : [],
                    features: route1?.markerPointDTOs || [],
                    center: route1?.centerPoint?.coOrdinatePoint || null,
                    defaultCenter: route1?.centerPoint?.coOrdinatePoint || null,

                    // -------- Route 2 --------
                    flightPlanCoordinates2: route2?.coOrdinatePointsJson
                        ? JSON.parse(route2.coOrdinatePointsJson)
                        : [],
                    features2: route2?.markerPointDTOs || [],

                    timeRemained
                    })
                } catch (err) {
                    console.log("Map API error", err)
                }
                }

  return (
    <>
        <AppToolBar
            //   backNavigate={() => this.props.history.push("/eventDetails")} //goBack()} //
            //   showBack={true}
            >
              <Header
              hideDrawer
                // {...this.props}
                label={`Ashish Kasodekar's Live Tracker`}
                // fromDate={eventDate}
                // toDate={eventDate === eventEnd ? false : eventEnd}
              />
            </AppToolBar>
            <div style={{marginTop:'70px'}}>
           {relayMapData &&  <RelayLeaderboard data={relayMapData} />}
            </div>
    </>
  )
}

export default LiveMap